import { render } from "./ManageClientDocuments.vue?vue&type=template&id=365781e2"
import script from "./ManageClientDocuments.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageClientDocuments.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Admin/ManageClientDocuments.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "365781e2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('365781e2', __exports__)) {
    api.reload('365781e2', __exports__)
  }
  
  module.hot.accept("./ManageClientDocuments.vue?vue&type=template&id=365781e2", () => {
    api.rerender('365781e2', render)
  })

}


export default __exports__